module.exports = __webpack_public_path__ + "img/customer-drive-innovation-guide.b9a89067.png";